module.exports = __webpack_public_path__ + "img/cost.cf893234.png";